import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const styles = theme => ({
  root: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.gray,
    // wordBreak: 'break-word',
    // whiteSpace: 'nowrap',
    ...theme.typography.p,
    color: '#01619B',
    fontSize: '0.95rem',
  },
});

const StyledTableCell = ({ size = 'small', classes, children }) => (
  <TableCell size={size} classes={classes}>
    {children}
  </TableCell>
);

StyledTableCell.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
};

export default withStyles(styles)(StyledTableCell);
